import React from 'react';
import '../styles/Help.css'; // Separate CSS for this window

const Help = ({ isDarkMode }) => {
    return (
        <div className={`help-container ${isDarkMode ? 'help-container-dark' : 'help-container-light'}`}>
            <div className='help-content-container'>
                <div className='help-heading'>
                    <h1>
                        Help <br /> Guide 🔍
                    </h1>   
                </div>

                <div className={`help-divider ${isDarkMode ? 'help-divider-dark' : 'help-divider-light'}`} />

                <div className='help-content'>
                    <p>
                        <span>Welcome to my portfolio!</span> If you’re having any trouble navigating the site, this section will guide you through each area. 🦋
                        <br /> <br />
                        Here’s how you can explore my portfolio :
                    </p>
                </div>
            </div>

            <div className='help-guide-container'>
            <table className='help-table'>
                <tr className='table-header-container'>
                    <th><div className={`table-header ${isDarkMode ? 'table-header-dark' : 'table-header-light'}`}>Section</div></th>
                    <th><div className={`table-header ${isDarkMode ? 'table-header-dark' : 'table-header-light'}`}>Description</div></th>
                </tr>
                <tr>
                    <td>🏠 Home</td>
                    <td>Return to the homepage any time by clicking on the logo or the “Home” button. Closes all opened windows.</td>
                </tr>
                <tr>
                    <td>🐻 About Me</td>
                    <td>Learn more about my background and career goals. Accessed via “About Me” in the navigation bar or desktop.</td>
                </tr>
                <tr>
                    <td>🛠 Expertise</td>
                    <td>See a list of programming languages, frameworks and tools I’m proficient in. Accessed via “Expertise” in the navigation bar or desktop.</td>
                </tr>
                <tr>
                    <td>🚀 Projects</td>
                    <td>Check out detailed descriptions of personal projects I’ve worked on. Accessed via “Projects” in the navigation bar or desktop. Coming soon...</td>
                </tr>
                <tr>
                    <td>✉️ Contact</td>
                    <td>Reach out to me directly via the contact form. Accessed via “Contact” in the navigation bar or via Messenger in the dock. Coming Soon...</td>
                </tr>
                <tr>
                    <td>🔗 LinkedIn</td>
                    <td>Access my LinkedIn profile via the dock.</td>
                </tr>
                <tr>
                    <td>🐱 GitHub</td>
                    <td>Access my GitHub profile via the dock.</td>
                </tr>
                <tr>
                    <td>🌗 Theme</td>
                    <td>Toggle between light and dark themes to personalise your browsing experience. Accessed via sun/moon logo in navigation bar.</td>
                </tr>
            </table>

            </div>
        </div>
    );
};

export default Help;
